import { render, staticRenderFns } from "./facebook.vue?vue&type=template&id=c1da8ee8&scoped=true"
import script from "./facebook.vue?vue&type=script&lang=js"
export * from "./facebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1da8ee8",
  null
  
)

export default component.exports